import { DRAWER_WIDTH, RESPONSIVE_PADDING, SCREEN_WIDTH } from 'constants/ui';

export const drawerStyles = {
  zIndex: 999,
};

export const paperStyles = {
  width: DRAWER_WIDTH,
  padding: RESPONSIVE_PADDING.DESKTOP,
  backgroundColor: ({ palette }) => palette.background.disabled,

  [`@media(max-width: ${SCREEN_WIDTH.M - 1}px)`]: {
    width: '100%',
    padding: RESPONSIVE_PADDING.MOBILE,
  },

  [`@media(min-width: ${SCREEN_WIDTH.M}px) and (max-width: ${SCREEN_WIDTH.L - 1}px)`]: {
    width: 'calc(100% - 100px)',
    padding: RESPONSIVE_PADDING.TABLET,
  },
};

export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const headerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 16px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '4px 4px 0 0',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const headerTitleStyles = {
  color: 'text.primary',
};

export const headerActionsStyles = {
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
};

export const saveButtonStyles = {
  padding: '4px 12px',
  minWidth: 'auto',
  textTransform: 'none',
  borderRadius: '6px',
};

export const cancelButtonStyles = {
  padding: '4px 12px',
  minWidth: 'auto',
  textTransform: 'none',
  borderRadius: '6px',
  color: 'text.secondary',
  borderColor: ({ palette }) => palette.border.input,

  '&:hover': {
    borderColor: ({ palette }) => palette.border.inputHover,
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
};

export const mainContentStyles = {
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '0 0 4px 4px',
};

export const bodyStyles = {
  flex: 1,
  overflow: 'auto',
  padding: '0 24px 16px 24px',
};

export const loaderWrapperStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
};

export const progressStyles = {
  color: ({ palette }) => palette.primary.main,
};

export const emptyStateStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  color: 'text.secondary',
};

export const closeButtonStyles = {
  minWidth: 'auto',
  padding: '4px',
  color: 'text.secondary',
  borderRadius: '6px',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
    color: 'text.primary',
  },
};

export const changesSummaryStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '8px',
  padding: '12px 0 4px 0',
};

export const expandCollapseButtonStyles = {
  marginLeft: '8px',
  padding: '2px 10px',
  minWidth: 0,
  textTransform: 'none',
};
